// tslint:disable:jsx-no-lambda
import React from "react";
import Slider, { Settings } from "react-slick";
import "./BB8Carousel.scss";
import BB8CarouselItem, {
  BB8CarouselItemStyle,
  IBB8CarouselItemItem
} from "./BB8CarouselItem";

interface IBB8Carousel extends Settings {
  data: any;
  styleType?: BB8CarouselItemStyle;
  onSelect?: (item: IBB8CarouselItemItem) => void;
  selectedItemId: string;
  allowEdit?: boolean;
  editItem?: (item: IBB8CarouselItemItem) => void;
}

interface IBB8CarouselState {
  selectedItem: any;
}

function CustomArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={style} onClick={onClick}>
      <img src={require("../assets/images/bb8-carousel-arrow-active.svg")} />
    </div>
  );
}

export default class BB8Carousel extends React.Component<
  IBB8Carousel,
  IBB8CarouselState
> {
  public static getDerivedStateFromProps(
    nextProps: IBB8Carousel,
    prevState: IBB8CarouselState
  ) {
    if (
      (nextProps.selectedItemId && !prevState.selectedItem) ||
      prevState.selectedItem.id === -9999
    ) {
      const selectedItem = nextProps.data.find(
        (item: IBB8CarouselItemItem) => item.id === nextProps.selectedItemId
      );
      if (selectedItem) {
        if (nextProps.onSelect) {
          nextProps.onSelect(selectedItem);
        }
        return {
          ...prevState,
          selectedItem
        };
      }
    }
    return { ...prevState };
  }
  public state = {
    selectedItem: {
      id: -9999
    }
  } as IBB8CarouselState;

  public render() {
    const {
      data,
      styleType,
      onSelect,
      allowEdit,
      editItem,
      ...slickProps
    } = this.props;

    const settings = {
      ...slickProps,
      ...{
        dots: true,
        infinite: this.props.data && this.props.data.length > 3,
        nextArrow: <CustomArrow />,
        prevArrow: <CustomArrow />
      }
    };
    return (
      <Slider className="BB8Carousel" {...settings}>
        {this.props.children}
        {this.props.data.map((item: IBB8CarouselItemItem) => (
          <BB8CarouselItem
            key={item.id + "-carousel-item"}
            item={item}
            allowEdit={this.props.allowEdit && item.id !== "unmapped"}
            select={(thisBB8CarouselItem: IBB8CarouselItemItem) =>
              this.selectCurrentPanel(thisBB8CarouselItem)
            }
            clickEdit={(thisBB8CarouselItem: IBB8CarouselItemItem) =>
              this.props.editItem && this.props.editItem(thisBB8CarouselItem)
            }
            selectedItem={this.state.selectedItem}
            styleType={this.props.styleType || BB8CarouselItemStyle.default}
          />
        ))}
      </Slider>
    );
  }

  public selectCurrentPanel(item: IBB8CarouselItemItem): void {
    this.setState({ selectedItem: item }, () => {
      if (this.props.onSelect) {
        this.props.onSelect(item);
      }
    });
  }
}
